import { on, get } from '@bigyouth/base'

import setAttributes from '../utils/setAttributes'
import removeAttributes from '../utils/removeAttributes'
import pressedKey from '../utils/pressedKey'
import { getTabbable, getAllTabbable } from '../utils/tabbable'
import { get as getPipe } from '../utils/sigpipe'
import { ACTIONS } from './modalControl'

export default {
  name: 'modal',

  ui: {
    'closeButtons[]': '[js-modal-close]',
  },

  events: [
    {
      on: 'click',
      target: 'closeButtons',
      handle: 'close',
    },
  ],

  componentDidMount () {
    this.pipe = getPipe(this.props)

    this.beforeBlocker = document.createElement('span')
    this.beforeBlocker.setAttribute('tabindex', 0)
    this.afterBlocker = this.beforeBlocker.cloneNode(true)

    this.offEscape = on('keyup', event => {
      if (pressedKey('esc')(event)) {
        this.close()
      }
    })(document.body)

    this.offBeforeBlock = on('focus', () => {
      const tabbables = getAllTabbable(this.el)
      tabbables[tabbables.length - 2].focus({ preventScroll: true })
    })(this.beforeBlocker)
    this.offAfterBlock = on('focus', () => {
      getTabbable(this.el).focus({ preventScroll: true })
    })(this.afterBlocker)

    this.el.parentNode.insertBefore(this.beforeBlocker, this.el)
    this.el.appendChild(this.afterBlocker)

    setAttributes({ jsSrInactive: '' })(get('.wrapper'))
    getTabbable(this.el).focus({ preventScroll: true })
  },

  close () {
    this.pipe.write(ACTIONS.CLOSE)
  },

  componentWillUnmount () {
    this.beforeBlocker.remove()
    this.afterBlocker.remove()

    this.offEscape()
    this.offBeforeBlock()
    this.offAfterBlock()

    removeAttributes('jsSrInactive')(get('.wrapper'))
  },
}
